import styled, { keyframes } from "styled-components";
import theme from "../../../Themes/light";

const dashAnimation = keyframes`
  0% {
    stroke-dasharray: 1, 95;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 85, 95;
    stroke-dashoffset: -25;
  }
  100% {
    stroke-dasharray: 85, 95;
    stroke-dashoffset: -93;
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const ImageUploadLogoContainer = styled.div`
  width: 100%;
  height: 6rem;
  .logo-input-container-empresa {
    width: 100%;
    height: 100%;
    .logo-wrapper {
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0rem 4rem;
      gap: 2rem;
      border-radius: 25rem;
      @media (max-width: 768px) {
        padding: 0rem;
      }
      .logo {
        height: 16rem;
        width: 16rem;

        @media (max-width: 768px) {
          height: 12rem;
          width: 12rem;
        }

        .loading {
          display: flex;
          align-items: center;
          svg {
            fill: transparent;
            stroke: ${(props) => props.theme.colors.elements};
            animation:
              ${dashAnimation} 2s ease infinite,
              ${rotateAnimation} 2s linear infinite;
            stroke-width: 1;
          }
        }
        .plus {
          border-radius: 50%;
          padding: 0.2rem;
          display: flex;
          align-items: center;
          width: 16rem !important;
          height: 16rem !important;
          background: ${(props) => props.theme.colors.modal};
          @media (max-width: 768px) {
            height: 12rem !important;
            width: 12rem !important;
          }
          svg {
            fill: ${(props) => props.theme.colors.tertiary};
            width: 4rem;
            height: 4rem;
            margin-left: 5.7rem;
          }
          .foto-usuario {
            width: 16rem !important;
            height: 16rem !important;
          }
        }
      }
      .texto {
        color: ${(props) => props.theme.colors.tertiary};
        padding-bottom: 2rem;
      }
    }
  }
`;

const ModalCroppingContainer = styled.div`
  width: 65rem;
  max-width: 100%;
  padding: 0 2rem;
  .titulo {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 2rem 0 1rem;
    font-weight: bold;
  }
  .remover-fundo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 2rem 2rem 0;
    color: ${(props) => props.theme.colors.tertiary};
  }
  .botoes {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 0 2rem;
    .cancelar {
      cursor: pointer;
      margin-top: 0 !important;
      color: ${(props) => props.theme.colors.tertiary};
    }
  }
`;

export { ImageUploadLogoContainer, ModalCroppingContainer };
